// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3ffSW","main_collection":"styles_main_collection__Z_J8f","bottom":"styles_bottom__FBDly"};